import { actionKey } from './constants';
export var getUploads = function (state) {
    return (state[actionKey] || {}).fileUploads || [];
};
export var getUploadById = function (state, fileId) {
    return getUploads(state).find(function (fu) { return fu.fileId === fileId; });
};
//# sourceMappingURL=selectors.js.map